import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular/standalone';
import { IonSelectCustomEvent, SelectChangeEventDetail } from '@ionic/core';
import { AppCommonModule } from 'src/app/common.module';
import { MainDialogComponent } from 'src/app/components/main-dialog/main-dialog.component';
import { NoResultsComponent } from 'src/app/components/no-results/no-results.component';
import { Site, SiteBlueprint } from 'src/app/models/site.model';
import { AppFabricComponent } from '../fabric.component';

@Component({
  selector: 'app-select-location-dialog',
  templateUrl: './select-location.dialog.html',
  styleUrls: ['./select-location.dialog.scss'],
  imports: [
    AppCommonModule,
    CommonModule,
    AppFabricComponent,
    MainDialogComponent,
    NoResultsComponent,
  ],
})
export class SelectLocationDialogComponent {
  private _modal = inject(ModalController);
  private navParams = inject(NavParams);

  blueprints = this.navParams.get<Site>('site').floors;

  imageElement = signal<HTMLImageElement>(null);
  selectedBlueprint = signal<SiteBlueprint>(null);
  items = signal<{ x: number; y: number; url: string }[]>([]);

  setBlueprintImage(img: Event) {
    const imgElement = img.target as HTMLImageElement;
    imgElement.crossOrigin = 'anonymous';
    setTimeout(() => this.imageElement.set(imgElement), 300);
  }

  onBlueprint(event: IonSelectCustomEvent<SelectChangeEventDetail<SiteBlueprint>>) {
    const blueprint = event.detail.value;
    this.selectedBlueprint.set(blueprint);
    const imageElement = new Image();
    imageElement.id = 'blueprint';
    imageElement.src = blueprint.url;
    imageElement.crossOrigin = 'anonymous';
    imageElement.className = 'canvas-img';
  }

  onSave(items: { x: number; y: number }[]) {
    const saved = items.map((it) => ({ x: it.x, y: it.y, url: this.selectedBlueprint().url }));
    this.items.set(saved);
  }

  saveItems() {
    this._modal.dismiss(this.items());
  }

  dismiss() {
    this._modal.dismiss();
  }
}
